document.querySelectorAll('[data-pack-selector]').forEach(selector=>{
  const form=selector.closest('form');
  const container=form.closest('.product');
  const price=container.querySelector('[data-product-price]');
  const button=form.querySelector('[data-product-add]');
  const quantity=form.querySelector('[data-product-quantity]');
  const status=form.querySelector('[data-product-status]');
  const pickers=[...form.querySelectorAll('[data-product-option]')];
  const image=container.querySelector('.product-primary img');
  const inquiry=container.querySelector('[data-product-inquiry]');
  const defaultImage=image?{src:image.getAttribute('src'),srcset:image.getAttribute('srcset'),alt:image.getAttribute('alt')}:null;
  const options=[...selector.options];
  const values=option=>JSON.parse(option.dataset.values||'[]');
  const update=()=>{
    const option=selector.selectedOptions[0];
    if(!option)return;
    const ready=option.dataset.available==='true';
    price.textContent=option.dataset.price;
    button.disabled=!ready;
    button.textContent=ready?button.dataset.ready:button.dataset.unavailable;
    quantity.max=ready?option.dataset.max:'1';
    quantity.value=Math.min(Math.max(1,Number(quantity.value)||1),Math.max(1,Number(option.dataset.max)));
    if(status)status.textContent=ready?status.dataset.ready:status.dataset.unavailable;
    const selected=values(option);
    pickers.forEach((picker,i)=>picker.value=selected[i]||picker.value);
    if(inquiry){const url=new URL(inquiry.href);url.searchParams.set('option',selected.join(' / '));inquiry.href=url.href;}
    if(image&&defaultImage){
      if(option.dataset.image){
        const url=new URL(option.dataset.image,location.href);
        image.src=url.href;
        image.srcset=[360,600,900].map(width=>{const sized=new URL(url);sized.searchParams.set('width',width);return sized.href+' '+width+'w';}).join(', ');
        image.alt=container.querySelector('h1').textContent+' / '+selected.join(' / ');
      }else{
        image.src=defaultImage.src;
        if(defaultImage.srcset)image.srcset=defaultImage.srcset;else image.removeAttribute('srcset');
        image.alt=defaultImage.alt;
      }
    }
  };
  selector.addEventListener('change',update);
  quantity.addEventListener('change',update);
  pickers.forEach(picker=>picker.addEventListener('change',()=>{
    const selected=pickers.map(x=>x.value);
    const match=options.find(option=>values(option).every((value,i)=>value===selected[i]));
    if(match){selector.value=match.value;update();const url=new URL(location.href);url.searchParams.set('variant',match.value);history.replaceState(null,'',url);}
    else{button.disabled=true;button.textContent=button.dataset.unavailable;if(status)status.textContent=status.dataset.unavailable;}
  }));
  form.addEventListener('submit',event=>{if(button.disabled)event.preventDefault();});
  update();
  if(pickers.length){form.querySelector('[data-option-pickers]').hidden=false;form.querySelector('[data-variant-fallback]').hidden=true;}
});
document.querySelectorAll('[data-mix-form]').forEach(form=>{const inputs=[...form.querySelectorAll('[data-mix-id]')];const submit=form.querySelector('[data-mix-submit]');const status=form.querySelector('[data-mix-status]');const total=form.querySelector('[data-mix-total]');if(!submit)return;const update=()=>{let sum=0;let count=0;inputs.forEach(input=>{const q=Math.min(Number(input.max)||0,Math.max(0,Math.floor(Number(input.value)||0)));if(!input.disabled){input.value=q;count+=q;sum+=q*Number(input.dataset.mixPrice);}});total.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD'}).format(sum/100);submit.disabled=count===0;};inputs.forEach(input=>input.addEventListener('input',update));form.querySelectorAll('[data-mix-preset]').forEach(button=>button.addEventListener('click',()=>{inputs.forEach(input=>input.value=0);button.dataset.mixPreset.split(',').forEach(item=>{const [id,q]=item.split(':');const input=inputs.find(x=>x.dataset.mixId===id);if(input&&!input.disabled)input.value=Math.min(Number(q),Number(input.max));});update();total.scrollIntoView({block:'nearest',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));form.addEventListener('submit',async e=>{e.preventDefault();const items=inputs.filter(input=>!input.disabled&&Number(input.value)>0).map(input=>({id:Number(input.dataset.mixId),quantity:Math.floor(Number(input.value))}));if(!items.length){status.textContent=form.dataset.empty;return;}submit.disabled=true;status.textContent='';try{const response=await fetch(form.dataset.cartAdd+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});const data=await response.json();if(!response.ok)throw new Error(data.description||form.dataset.error);window.location.assign(form.dataset.cartUrl);}catch(error){status.textContent=error.message||form.dataset.error;update();}});update();});
document.querySelectorAll('[data-inquiry-prefill]').forEach(field=>{
  const params=new URL(location.href).searchParams;
  const shape=params.get('shape');
  const option=params.get('option');
  if(shape&&!field.value)field.value=shape+(option?' — '+option:'');
});

document.querySelectorAll('.mobile-menu').forEach(menu=>{
  menu.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.open){menu.open=false;menu.querySelector('summary').focus();}});
  document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target))menu.open=false;});
  menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{menu.open=false;}));
});

document.querySelectorAll('[data-minimum-order-form]').forEach(form=>{
  const checkout=form.querySelector('[data-minimum-checkout]');
  const status=form.querySelector('[data-minimum-status]');
  if(!checkout||!status)return;
  const belowMinimum=Number(form.dataset.cartSubtotal)<Number(form.dataset.minimumCents);
  let quantitiesChanged=false;
  form.querySelectorAll('input[name="updates[]"]').forEach(input=>{
    input.addEventListener('input',()=>{
      quantitiesChanged=true;
      checkout.disabled=true;
      status.hidden=false;
      status.textContent=form.dataset.updateMessage;
    });
  });
  form.addEventListener('submit',event=>{
    if(event.submitter?.name!=='checkout')return;
    if(belowMinimum||quantitiesChanged){
      event.preventDefault();
      status.hidden=false;
      if(quantitiesChanged)status.textContent=form.dataset.updateMessage;
      status.focus();
    }
  });
});
